import React, { useState, useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/CloseRounded';

export default function AiRateModal(props) {
    const [data, setData] = useState()
        
    const apply = () => {
        props.onApply(data)
    }
    
    useEffect(() => {
        setData(props.data)
    }, [props.data])
        
    return (
        <Dialog open={props.data !== null ? true : false} onClose={() => {props.onClose()}} fullWidth maxWidth="sm" >
            <DialogTitle id="alert-dialog-title">
                AI Rate
                <IconButton
                    onClick={props.onClose}
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Stack direction="row" spacing={2}>
                    <TextField 
                        id="content"
                        fullWidth
                        margin="dense"
                        name="query"
                        label="Query"
                        variant="filled"
                        multiline
                        rows={5}
                        defaultValue={data}
                        onChange={(e) => {setData(e.target.value)}}
                    /> 
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {props.onClose()}}>Close</Button>
                <Button onClick={apply} autoFocus>Apply</Button>
            </DialogActions>
        </Dialog>
    )
}